import { render, staticRenderFns } from "./ComprometimentoAnexoDownload.vue?vue&type=template&id=752837fc&"
import script from "./ComprometimentoAnexoDownload.vue?vue&type=script&lang=js&"
export * from "./ComprometimentoAnexoDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports